import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="bg-gray-900 text-white py-4">
      <div className="container mx-auto">
        <h1 className="text-2xl font-bold">Udaya Krishna Shrestha</h1>
        <p className='mb-3'>Totally in love with Prinsha Shrestha ❤️</p>
        <span className=''>Email: shresthaudayakrishna@gmail.com</span>
      </div>
    </header>
  );
};

export default Header;
